import styled from "styled-components";

const Cards = styled.div`
  &:hover {
    img {
      width: 56px;
      height: 56px;
    }
  }

  img {
    transition: all 0.3s ease-in-out;
  }
`;

export default function Services() {
  const services = [
    {
      title: "Cosmetics & Chemical Manufacturing",
      description:
        "Cycle-time acceleration, batch line balancing, material-loss reduction, and FDA-aligned process controls.",
      image:
        "https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/image9-f96522f2-7919-4571-923c-9c9039e2a8b6.svg",
    },
    {
      title: "Ammunition & Precision Assembly",
      description:
        "Error-proofing (Poka-Yoke), defect elimination, throughput scaling, and secure hazardous inventory management.",
      image:
        "https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/image10-841070a3-5b03-49ad-a431-ab276eb07968.svg",
    },
    {
      title: "Industrial & Ammonia Refrigeration",
      description:
        "Cold-chain efficiency, space and thermal envelope planning, and high-consequence OSHA compliance auditing.",
      image:
        "https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/image11-5b7eb2a3-36d2-4bee-a8a1-19b54cc487ee.svg",
    },
    {
      title: "Lean Six Sigma Operational Efficiency",
      description:
        "Waste elimination, DMAIC project leadership, and measurable process gains across industrial floors.",
      image:
        "https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/image12-1b9a91b5-b1aa-471e-97de-4f47c3f91029.svg",
    },
  ];

  return (
    <div className="container relative py-16 md:py-36 flex lg:flex-row flex-col">
      <div className="lg:max-w-[572px] w-full flex-col justify-start items-start gap-2 inline-flex">
        <div className="p-2 bg-[#e6f1ff] rounded-md justify-center items-center gap-2 inline-flex">
          <div className="whitespace-nowrap text-[#2b8cff] text-base font-medium font-secondary leading-[19px]">
            SERVICES
          </div>
        </div>
        <div className="max-w-[572px] w-full text-[#0e0e0e] text-2xl md:text-[32px] font-semibold font-primary leading-[41.60px] mb-12">
          Specialized Expertise for High-Barrier Industrial Sectors
        </div>
        <div className="overflow-hidden flex-col justify-start items-center inline-flex rounded-md w-full lg:w-auto mr-4 xl:mr-0">
          <img
            src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919%2Fe7d54f20-290b-4fdd-8690-d8faefab6c93.png"
            alt="image 26"
            className="object-cover inset-0 w-full h-full transition-all duration-500 hover:scale-[1.4]"
          />
        </div>
      </div>
      <div className="flex-wrap w-full lg:mt-[182px] mt-12 justify-between items-start flex bg-white gap-y-10">
        {services.map((service, index) => (
          <Cards
            key={index}
            className="w-full lg:w-[49%] lg:max-w-[320px] p-5 flex-col justify-start items-start inline-flex bg-gray-50 rounded-md"
          >
            <div className="self-stretch flex-col justify-start items-start gap-6 flex">
              <img
                src={service.image}
                className="w-10 h-10"
                alt={`image ${index + 1}`}
              />
            </div>
            <hr className="w-full border-0 my-4 border-t border-[#e5e5e5]" />
            <div className="self-stretch flex-col justify-start items-start gap-3 flex">
              <div className="self-stretch text-[#0e0e0e] text-xl font-normal font-primary leading-7">
                {service.title}
              </div>
              <div className="self-stretch text-neutral-500 text-base font-normal font-primary leading-[22.40px] tracking-[0.01em]">
                {service.description}
              </div>
            </div>
          </Cards>
        ))}
      </div>
      <img
        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Rectangle1-17375161-56d7-4966-9934-eeea32dd825e.svg"
        alt="Rectangle 1"
        style={{ justifySelf: "anchor-center" }}
        className="absolute top-0 right-0 w-10 md:w-auto"
      />
      <img
        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/image2-dcb5b3d6-7932-48b4-9125-1f7c1321a5c7.svg"
        alt="image 2"
        className="absolute top-[59px] right-[22px]"
      />
    </div>
  );
}
